import { useState, useEffect, useRef } from 'react';
import { fetchUserPaymentMethods } from '@/services/userPaymentMethodsService';

export const usePaymentCardSelector = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userCards, setUserCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  const cardTypesCatalog = [
    {
      type: 'visa',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg',
      name: 'Visa',
    },
    {
      type: 'mastercard',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg',
      name: 'Mastercard',
    },
    {
      type: 'amex',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg',
      name: 'American Express',
    },
    {
      type: 'discover',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/5/57/Discover_Card_logo.svg',
      name: 'Discover',
    },
  ];

  useEffect(() => {
    const getCards = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetchUserPaymentMethods();
        console.log('CARDS API RAW:', response);

        if (Array.isArray(response)) {
          const formattedCards = response.map(card => {
            const detailsLower = card?.details?.toLowerCase() || '';
            let detectedType = 'visa';
            if (detailsLower.includes('master')) detectedType = 'mastercard';
            else if (detailsLower.includes('american')) detectedType = 'amex';
            else if (detailsLower.includes('discover'))
              detectedType = 'discover';
            else if (detailsLower.includes('visa')) detectedType = 'visa';

            const visualData =
              cardTypesCatalog.find(t => t.type === detectedType) ||
              cardTypesCatalog[0];

            return {
              ...card,
              isDefault: card.isDefault === '1' || card.isDefault === 1,
              type: detectedType,
              icon: visualData.icon,
              name: visualData.name,
            };
          });

          console.log('CARDS FORMATTED:', formattedCards);

          setUserCards(formattedCards);
          const defaultCard = formattedCards.find(card => card.isDefault);
          setSelectedCard(defaultCard || formattedCards[0] || null);
        }
      } catch (err) {
        console.error('Error fetching cards:', err);
        setError('Error loading cards');
      } finally {
        setLoading(false);
      }
    };

    getCards();
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCardSelect = card => {
    setSelectedCard(card);

    const updatedCards = userCards.map(c => ({
      ...c,
      isDefault: c.id === card.id,
    }));
    setUserCards(updatedCards);
    setOpenDropdownId(null);
  };

  const toggleDropdown = cardId => {
    setOpenDropdownId(prev => (prev === cardId ? null : cardId));
  };

  return {
    loading,
    error,
    selectedCard,
    dropdownRef,
    cardTypes: userCards,
    openDropdownId,
    handleCardSelect,
    toggleDropdown,
  };
};
